import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api, fmtDateTime } from "@/lib/api";
import { Avatar, PageLoader, StatusBadge } from "@/components/common";

const Row = ({ k, v }) => <div className="flex justify-between gap-4 border-b border-slate-100 py-2 text-sm"><span className="text-slate-500">{k}</span><span className="text-right font-medium text-[#0B1A33]">{v || "—"}</span></div>;

export function UserDetailDialog({ userId, onClose }) {
  const [u, setU] = useState(null);
  useEffect(() => {
    setU(null);
    if (userId) api.get(`/admin/users/${userId}`).then((r) => setU(r.data));
  }, [userId]);
  return (
    <Dialog open={!!userId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-2xl" data-testid="user-detail-dialog">
        {!u ? <PageLoader /> : (
          <>
            <DialogHeader>
              <div className="flex items-center gap-4">
                <Avatar src={u.profile_picture} name={u.name} size="h-14 w-14" />
                <div><DialogTitle>{u.name}</DialogTitle><p className="text-sm text-slate-500">{u.email}</p>
                  <div className="mt-1 flex gap-2"><StatusBadge status={u.approval_status} />{!u.is_active && <StatusBadge status="inactive" />}</div></div>
              </div>
            </DialogHeader>
            <Tabs defaultValue="profile">
              <TabsList>
                <TabsTrigger value="profile" data-testid="detail-tab-profile">Profile</TabsTrigger>
                <TabsTrigger value="sessions" data-testid="detail-tab-sessions">Sessions ({u.sessions?.length || 0})</TabsTrigger>
                {u.role === "student" && <TabsTrigger value="credits" data-testid="detail-tab-credits">Credits</TabsTrigger>}
              </TabsList>
              <TabsContent value="profile">
                <Row k="Phone" v={u.phone} />
                {u.role === "student" ? <Row k="Education level" v={u.education_level} /> : (
                  <><Row k="Subject" v={u.subject} /><Row k="Specialization" v={u.specialization} /><Row k="Qualification" v={u.qualification} />
                    <Row k="Experience" v={`${u.experience} years`} /><p className="mt-3 text-sm text-slate-600">{u.bio}</p></>
                )}
                <Row k="Email verified" v={u.email_verified ? "Yes" : "No"} />
                <Row k="Registered" v={fmtDateTime(u.created_at)} />
                {u.role === "student" && <><Row k="Available credits" v={String(u.wallet.available)} /><Row k="Reserved credits" v={String(u.wallet.reserved)} /><Row k="Credits used" v={String(u.wallet.used)} /></>}
              </TabsContent>
              <TabsContent value="sessions" className="space-y-2">
                {(u.sessions || []).length === 0 && <p className="py-4 text-sm text-slate-500">No sessions yet.</p>}
                {(u.sessions || []).map((s) => (
                  <div key={s.id} className="flex items-center justify-between rounded-xl border border-slate-100 p-3 text-sm">
                    <div><p className="font-semibold text-[#0B1A33]">{s.title}</p><p className="text-slate-500">{fmtDateTime(s.start_at)} · {s.tutor_name}</p></div>
                    <StatusBadge status={s.status} />
                  </div>
                ))}
              </TabsContent>
              {u.role === "student" && (
                <TabsContent value="credits" className="space-y-2">
                  {(u.transactions || []).map((t) => (
                    <div key={t.id} className="flex items-center justify-between rounded-xl border border-slate-100 p-3 text-sm">
                      <div><p className="font-semibold capitalize text-[#0B1A33]">{t.type} · {t.reason}</p><p className="text-slate-500">{fmtDateTime(t.created_at)}</p></div>
                      <span className={`font-bold ${t.amount >= 0 ? "text-[#2DA638]" : "text-red-500"}`}>{t.amount > 0 ? "+" : ""}{t.amount}</span>
                    </div>
                  ))}
                </TabsContent>
              )}
            </Tabs>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
